import React from "react";
import {findDOMNode} from "react-dom";

// @ts-ignore
import SelectProgressPopover from "src/core/gd-ui/select-progress/components/popover";
import FormManager from "../../../../../gd-form/common/form-manager";

export default function FieldProgress_Popover(props:any) {
    let form    : any;

    const onSelectorItemClick = (value:any) => {
        props.parent.hidePopover();
        props.parent.onValueChange(value);
    }

    const onProgressChange = (value:any) => {
        // const progress = value > 100 ? 100 : value < 0 ? 0 : value;
        // form.setValue("progress", progress);
        form.setValue("progress", value);
    }

    const onSubmit = (result:any) => onSelectorItemClick(result.progress);

    const initFormData = {
        progress: props.value
    };

    const formStructure = {
        fields: {
            progress: {type: 'select', isRequired: false}
        },
        onSubmit: onSubmit
    };

    form = new FormManager(formStructure,initFormData);

    return (
        <SelectProgressPopover form={form}
                               attachment="top center"
                               targetAttachment="bottom center"
                               getTargetFunc={()=>findDOMNode(props.parent)}
                               onClickOutside={()=>{props.parent.hidePopover()}}
                               onSelectorItemClick={onSelectorItemClick}
                               onProgressChange={onProgressChange} />
    )
}
